module.exports = __webpack_public_path__ + "static/media/Femi Olofintila.9963481b.jpeg";